import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Container } from "../components/ui/Container";
import { Stack } from "../components/ui/Stack";
import { Heading } from "../components/ui/Heading";
import { Text } from "../components/ui/Text";
import { Button } from "../components/ui/Button";
import { Card } from "../components/ui/Card";
import { Alert } from "../components/ui/Alert";
import { useTranslation } from "react-i18next";
import { useCart } from "../context/CartContext";

export const CheckoutCancel: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { cart } = useCart();

  const token = searchParams.get("token");

  return (
    <div className="w-full bg-white py-8 min-h-screen">
      <Container>
        <div className="max-w-2xl mx-auto">
          <Stack spacing="lg" align="center">
            <div className="text-center">
              <Heading size="2xl" className="mb-4 text-gray-900">
                {t("checkout.cancel.title") || "Payment Canceled"}
              </Heading>
              <Text size="lg" className="text-gray-600 mb-4">
                {t("checkout.cancel.message") || "Your payment was canceled and no charges were made."}
              </Text>
              {token && (
                <Text size="sm" className="text-gray-500 mb-4">
                  {t("checkout.cancel.token") || "Transaction ID"}: {token}
                </Text>
              )}
            </div>

            <Card padding="lg" className="w-full">
              <Alert variant="info" className="mb-4">
                {t("checkout.cancel.info") || 
                  "You can continue shopping or return to checkout to complete your purchase."}
              </Alert>

              <Stack spacing="md">
                {cart && cart.items && cart.items.length > 0 ? (
                  <>
                    <Button
                      variant="primary"
                      onClick={() => navigate("/checkout")}
                      className="w-full"
                    >
                      {t("checkout.cancel.returnToCheckout") || "Return to Checkout"}
                    </Button>
                    <Button
                      variant="outline"
                      onClick={() => navigate("/cart")}
                      className="w-full"
                    >
                      {t("checkout.cancel.viewCart") || "View Cart"}
                    </Button>
                  </>
                ) : (
                  <Button
                    variant="primary"
                    onClick={() => navigate("/products")}
                    className="w-full"
                  >
                    {t("checkout.cancel.continueShopping") || "Continue Shopping"}
                  </Button>
                )}
              </Stack>
            </Card>

            <Text size="sm" className="text-gray-500 text-center">
              {t("checkout.cancel.helpText") || 
                "If you encountered any issues during checkout, please contact our support team."}
            </Text>
          </Stack>
        </div>
      </Container>
    </div>
  );
};

export default CheckoutCancel;
